import watchForHover from 'lib/input-detector';

import config from 'config';
import dev from 'dev';
import layout from 'layout';
import utils from 'utils';

const $ = window.$;

const EasingFunctions = {
  // no easing, no acceleration
  linear: t => t,
  // accelerating from zero velocity
  easeInQuad: t => t*t,
  // decelerating to zero velocity
  easeOutQuad: t => t*(2-t),
  // acceleration until halfway, then deceleration
  easeInOutQuad: t => t<.5 ? 2*t*t : -1+(4-2*t)*t,
  // accelerating from zero velocity 
  easeInCubic: t => t*t*t,
  // decelerating to zero velocity 
  easeOutCubic: t => (--t)*t*t+1,
  // acceleration until halfway, then deceleration 
  easeInOutCubic: t => t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1,
  // accelerating from zero velocity 
  easeInQuart: t => t*t*t*t,
  // decelerating to zero velocity 
  easeOutQuart: t => 1-(--t)*t*t*t,
  // acceleration until halfway, then deceleration
  easeInOutQuart: t => t<.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t,
  // accelerating from zero velocity
  easeInQuint: t => t*t*t*t*t,
  // decelerating to zero velocity
  easeOutQuint: t => 1+(--t)*t*t*t*t,
  // acceleration until halfway, then deceleration 
  easeInOutQuint: t => t<.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t
}

window.addEventListener('DOMContentLoaded', () => {

  watchForHover();

  // Init
  layout.init();
  if(config.dev) {
    dev.init();
  }

  // Fade effect on scroll 
  window.AOS.init({
    easing: 'ease-out-back'
  });

  // Load and apply data from GSheets
  loadData();

  // Pineapple parallax effect
  $(window).on('scroll', function () {
    // Update parallax
    if(!window.disableParallax) {
      requestAnimationFrame(updateParallax);
    }

    // Start votes animation
    if(window.dataReady && !window.votesShown) {
      const votesWrap = $('.votes-wrap').get(0),
            votesBbox = votesWrap.getBoundingClientRect();

      if(votesBbox.top < window.innerHeight / 2) {
        window.votesShown = true;
        $(window).trigger('showvotes');
      }
    }
  }).scroll();

  // Force scroll on resize
  $(window).on('resize orientationchange', _ => $(window).scroll());

  // GA events
  $('[data-origin]').on('click', event => {
    const map   = {
                    'vote-instagram': 'Instagram',
                    'vote-twitter':   'Twitter',
                    'vote-facebook':  'Facebook',
                    'vote-tiktok':    'TikTok',
                    'order':          'Pedir pizza'
                  },
          label = map[event.target.dataset.origin];

    if(window.ga) {
      window.ga('send', 'Button', 'click', label);
    }
  });

  // Show votes handler
  $(window).on('showvotes', () => {
    const start         = Date.now(),
          duration      = 3 * 1000,
          saveHeight    = window.votes.savePercent / 100,
          destroyHeight = window.votes.destroyPercent / 100,
          $save         = $('[data-origin="percent-save"]'),
          $destroy      = $('[data-origin="percent-destroy"]');
    
    function nextFrame() {
      const now        = Date.now(),
            lapsed     = now - start,
            ratio      = Math.min(1, lapsed / duration),
            easedRatio = EasingFunctions.easeInOutQuad(ratio);
            
      $save.text(Math.round(100 * easedRatio * saveHeight));
      $destroy.text(Math.round(100 * easedRatio * destroyHeight));
      utils.setCssVar('save-height', easedRatio * saveHeight);
      utils.setCssVar('destroy-height', easedRatio * destroyHeight);

      if(lapsed < duration) {
        requestAnimationFrame(nextFrame);
      } else {
        if(saveHeight >= destroyHeight) {
          $('.vote-wrap.save .counter-icon').addClass('winner');
        }
        if(destroyHeight >= saveHeight) {
          $('.vote-wrap.destroy .counter-icon').addClass('winner');
        }
      }
    }

    requestAnimationFrame(nextFrame);
    $('.counter-grow').removeClass('load');
  });
});

function updateParallax() {
  $('[data-parallax]').each(function () {
    const scrollY       = window.scrollY,
          screenHeight  = window.innerHeight,
          $item         = $(this),
          transformX    = $item.data('parallax').split(',')[0],
          transformY    = $item.data('parallax').split(',')[1],
          rotate        = $item.data('parallax').split(',')[2],
          itemHeight    = $item.outerHeight(),
          itemTop       = screenHeight - scrollY, 
          scrollMin     = itemTop - screenHeight,
          scrollMax     = scrollMin + itemHeight + screenHeight,
          t             = -.5 + (scrollY - scrollMin) / (scrollMax - scrollMin);

    this.style.transform = `translate3d(${t * transformX}%,${t * transformY}%,0) rotate(${t * rotate}deg)`;
  });
}

function loadData() {
  const url             = 'https://docs.google.com/spreadsheets/d/1ETbCBj3F0RDDzeedCdwc5eFwpJ1xBkAvn_JCk2CKRdg/gviz/tq?tqx=out:json',
        now             = Date.now(),
        cachedResponse  = localStorage.getItem('googleSheetData'),
        cacheTimestamp  = parseInt(localStorage.getItem('googleSheetTimestamp')),
        maxCacheAge     = 60 * 60 * 1000;
  let   promise, storeInCache;

  if(cachedResponse && (now - cacheTimestamp) < maxCacheAge) {
    promise = Promise.resolve(cachedResponse);
  } else {
    promise = $.get(url);
    storeInCache = true;
  }
  
  return promise.then(response => {
    const json = response.replace(/^[^{]*/, '').replace(/\);$/, ''),
          data = JSON.parse(json),
          sheet = {};

    // Parse sheet data
    data.table.rows.forEach((row, rowIndex) => {
      if(row.c) {
        row.c.forEach((cell, colIndex) => {
          if(cell) {
            const colName = data.table.cols[colIndex].id;
            if(!sheet[colName]) {
              sheet[colName] = [];
            }
            sheet[colName][rowIndex + 1] = cell.f ? cell.f : cell.v;
          }
        })
      }
    });
    
    // Extract values
    const votesFor            = parseInt(sheet.D[14]),
          votesAgainst        = parseInt(sheet.D[15]),
          countDate           = sheet.C[18].replace(/\//g, '.').replace('2021', '21'),
          voteOnInstagramUrl  = sheet.A[20], 
          voteOnTwitterUrl    = sheet.A[22], 
          voteOnFacebookUrl   = sheet.A[24], 
          voteOnTikTokUrl     = sheet.A[26],
          orderUrl            = sheet.A[28],
          mainVideoUrl        = sheet.A[30],
          spotVideoUrl        = sheet.A[32],
          spotVideoThumbnail  = sheet.A[34],
          gaTrackingCode      = sheet.A[36];

    // Load Analytics and track page view
    if(gaTrackingCode && window.ga) {
      ga('create', gaTrackingCode, 'auto');
      ga('send', 'pageview');
    }

    // Compute percents
    const totalVotes      = votesFor + votesAgainst,
          savePercent     = Math.round(totalVotes ? 100 * votesFor / totalVotes : 50),
          destroyPercent  = 100 - savePercent;
    
    // Apply values
    $('[data-origin="date"]').text(countDate);
    $('[data-origin="vote-instagram"]').attr('href', voteOnInstagramUrl);
    $('[data-origin="vote-twitter"]').attr('href', voteOnTwitterUrl);
    $('[data-origin="vote-facebook"]').attr('href', voteOnFacebookUrl);
    $('[data-origin="vote-tiktok"]').attr('href', voteOnTikTokUrl);
    $('[data-origin="order"]').attr('href', orderUrl);
    $('[data-origin="youtube-main"]').attr('href', mainVideoUrl);
    $('[data-origin="youtube-spot"]').attr('href', spotVideoUrl);
  
    // Make votes available
    window.votes = {
      savePercent: savePercent,
      destroyPercent: destroyPercent
    };

    // Show extra section if needed
    $('.video-section.promo').toggleClass('hidden', !spotVideoUrl);
    $('[data-origin="spot-thumbnail"]').attr('src', spotVideoThumbnail);

    // Init video lightbox
    window.GLightbox({ selector: '.glightbox' });

    // Force scroll
    window.dataReady = true;
    $(window).scroll();

    // Store in cache?
    if(storeInCache) {
      localStorage.setItem('googleSheetData', response);
      localStorage.setItem('googleSheetTimestamp', Date.now());
    }
  });  

}